import BasicCard from "../../../components/basics/cards/BasicCard";
import { Tooltip, OverlayTrigger } from 'react-bootstrap';
import './upload.css';
import { useEffect, useState } from 'react';
import { UploadAPIService } from "../../../services/apis/UploadAPIService";

function UploadActions({ refreshSource }) {
  
    console.log('UploadActions-refreshSource::' + refreshSource);
    
    const [logMessages, setLogMessages] = useState([]);
    useEffect(() => {
        const fetchLogMessages = async () => {
            const actualSource = (typeof refreshSource === 'string' && refreshSource.includes(','))
                ? refreshSource.split(',')[0] : refreshSource;
            console.log('UploadActions-actualSource::' + actualSource);
            const data = await UploadAPIService.getLogMessages(actualSource);
            setLogMessages(data);
        // We need to restart this from Upload button.
        // After that this code can be placed back.
            if (data?.length > 0 && data[0].isFinished) {
                console.log(data[0].isFinished);
                if (interval !== undefined) {
                    clearInterval(interval);
                }
            }
        };
        // Fetch log messages initially
        fetchLogMessages();

        // Set up interval to fetch new messages every second
        const interval = setInterval(fetchLogMessages, 1000);

        // Clean up interval on component unmount
        return () => clearInterval(interval);
    }, [refreshSource]);

    return (
        <BasicCard cardConfig={{ cardTitle: 'Actions ', cardHeadingElement: 'h5' }}>

            <table className='upload-table'>
                <tbody>
                    {logMessages && logMessages.length > 0 ? (
                        logMessages.map(log => <tr key={log.id}><td>
                            <OverlayTrigger
                                placement={'top'}
                               
                                overlay={
                                    <Tooltip>
                                        {log.messageToolTip}
                                    </Tooltip>
                                }
                            >
                                <p className="bi bi-align-center">{log.message}</p>
                            </OverlayTrigger>
                               
                  
                        </td><td>{log.logDate}</td></tr>)
                    ) : (
                        <tr>
                            <td>No log messages found.</td>
                        </tr>
                    )}
                </tbody>
            </table>
        </BasicCard>
    );
}

export default UploadActions;